export function saveSession(data) {
  localStorage.setItem('token', data.token);
  localStorage.setItem('userInfo', JSON.stringify(data));
}

export function clearSession() {
  localStorage.removeItem('token');
  localStorage.removeItem('userInfo');
}

export function isAuthenticated() {
  return Boolean(localStorage.getItem('token'));
}

/** Current admin, normalised for display. */
export function getCurrentUser() {
  let info = {};
  try {
    info = JSON.parse(localStorage.getItem('userInfo')) ?? {};
  } catch {
    // corrupted storage; fall back to defaults
  }
  const name = info.name ?? info.fullName ?? info.email ?? 'Admin';
  const initials = name
    .split(/[\s@.]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join('');
  return { name, initials, role: info.role ?? 'Admin', email: info.email };
}
